'use client';

import { apiRequest, refreshAccessToken } from "./api_request";

export async function handleRequest(
  endpoint: string,
  method: string = "GET",
  body: any,
  update: (session: any) => void
) {
  let response = await apiRequest(endpoint, method, body)

  if (response.status == 401) {
    const refreshTokenRes = await refreshAccessToken()

    if (refreshTokenRes.status == 200) {
      const data = refreshTokenRes.data
      await update({
        user: {
          access_token: data.access_token,
          access_token_expires_at: data.access_token_expires_at,
        }
      });

      response = await apiRequest(endpoint, method, body, data.access_token)
    }
  }

  return response
}